import React from 'react';
import { Trash2 } from 'lucide-react';
import { MRT_TableInstance } from '@talentmesh/table';
import { Button } from '@/Components/shadcn';
import { useInviteCandidateContext } from '../../Contexts/InviteCandidateContext';
import UIStrings from '@/Utils/UIStrings';
import { CandidateRowEntry } from '@/Models/CandidateRowEntry';

interface CandidatesListHeaderProps {
    table: MRT_TableInstance<CandidateRowEntry>;
}

const CandidatesListHeader = ({ table }: CandidatesListHeaderProps): React.JSX.Element => {
    const { deleteCandidatesAsync } = useInviteCandidateContext();
    const selectedRows = table.getSelectedRowModel().rows;
    const getSelectedRowIds = (): Array<string> => {
        return selectedRows.map((item) => item.original.id);
    };

    const handleDelete = async (): Promise<void> => {
        await deleteCandidatesAsync(getSelectedRowIds());
        table.resetRowSelection();
    };

    return (
        <div className="flex flex-row items-start gap-2 border-b p-4">
            <Button
                type="button"
                size="xs"
                variant="destructive-outline"
                disabled={selectedRows.length === 0}
                onClick={handleDelete}
                className="shrink-0 gap-2"
                data-cy="deleteBatchButton"
                aria-label="Delete selected"
            >
                <Trash2 className="size-4" />
                {`${UIStrings.Delete} (${selectedRows.length})`}
            </Button>
        </div>
    );
};

export default CandidatesListHeader;
